  <mat-card id="alpaca-card" (click)="navigateToDetails(alpaca)" style="cursor: pointer;">
    <mat-card-header>
      <mat-card-title>
        <h3>{{ alpaca.shortName }}</h3>
      </mat-card-title>
        <div class="alpaca-fullname">{{alpaca.longName}}</div>
    </mat-card-header>
    <mat-card-content>
      <img loading="lazy" src="{{alpacaMainImageUrl}}{{alpaca.mainImage.name}}" alt="{{alpaca.longName}}" class="alpaca-image"/>
      <div class="card-body">
        <table>
          <tr>
            <td class="label">Soort:</td>
            <td>{{ alpaca.breed }}</td>
          </tr>
          <tr>
            <td class="label">Geslacht:</td>
            <td>{{ alpaca.gender }}</td>
          </tr>
          <tr>
            <td class="label">Kleur:</td>
            <td>{{ alpaca.color }}</td>
          </tr>
          <tr>
            <td class="label">Geboortedatum:</td>
            <td>{{ alpaca.dateOfBirth | date: 'dd-MM-yyyy' }}</td>
          </tr>
          <tr>
            <td class="label">Vader:</td>
            <td>
              @if(alpaca.sire) { <div>{{ alpaca.sire.longName }}</div> }
              @if(alpaca.sireName) { <div>{{ alpaca.sireName }}</div> }
            </td>
          </tr>
          <tr>
            <td class="label">Moeder:</td>
            <td>
              @if(alpaca.dam) { <div>{{ alpaca.dam.longName }}</div> }
              @if(alpaca.damName) { <div>{{ alpaca.damName }}</div> }
            </td>
          </tr>
        </table>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <div class="extra-info">
        @if (alpaca.category === 'Dekhengsten' && alpaca.studFee > 0) { <div>Dekgeld: {{alpaca.studFee | currency}} excl. 21% btw</div> }
        @if (alpaca.status === 'Te koop' && alpaca.sellPrice > 0) { <div>Te koop: {{alpaca.sellPrice | currency}} incl. 21% btw</div> }
        @if (alpaca.status === 'Te koop' && alpaca.sellPrice === 0) { <div>Te koop: Prijs op aanvraag</div> }
      </div>
      <button class="button-standard-action icon-button" mat-raised-button (click)="navigateToDetails(alpaca)">
        Lees meer  <mat-icon>double_arrow</mat-icon>
      </button>
    </mat-card-actions>
  </mat-card>
